import React, { useContext, useEffect } from "react";
import BryntumContext from "../../context/bryntumContext.jsx";
import { deselectionOnHeaderClick, handleHeaderButtonMenuShowOnHover } from "../../../other/utils/utils.jsx";
import LastUpdateText from "./lastUpdateText/LastUpdateText.jsx";
import AppBoardButton from "./headerButtons/appBoardButton/AppBoardButton.jsx";
import AppViewButton from "@/react/components/appHeader/headerButtons/appViewButton/AppViewButton.jsx";
import AppAddButton from "./headerButtons/appAddButton/AppAddButton.jsx";
import RecentViewsQuickActions from "./RecentViewsQuickActions.jsx";
import AppSelectedViewButton from "./headerButtons/appSelectedViewButton/AppSelectedViewButton.jsx";
import { SwivuEntityFinder } from "@/modern/components/entity-finder/SwivuEntityFinder";
import { ChangelogBell } from "@/react/components/changelog";

export default function MainHeader() {
  const context = useContext(BryntumContext);
  const { viewManager, user, selectedBoard } = context;

  const canShowButtons = Boolean(user) && Boolean(selectedBoard);

  useEffect(() => {
    if (viewManager) {
      const detacher = deselectionOnHeaderClick(() => {
        if (viewManager?.pageViewsRef) {
          return Object.values(viewManager.pageViewsRef);
        }
      });

      return () => {
        detacher();
      };
    }
  }, [viewManager]);

  useEffect(() => {
    return handleHeaderButtonMenuShowOnHover();
  }, []);

  return (
    <>
      {/* Left Side: App-level navigation */}
      <div className="flex md:justify-start justify-center items-center gap-3">
        <AppViewButton />
        <RecentViewsQuickActions />
        {canShowButtons && (
          <div className="ml-3">
            <AppSelectedViewButton />
          </div>
        )}
      </div>
      {/* Right Side: Board info and app-level actions */}
      <div className="flex items-start justify-end gap-3">
        <div className="flex flex-col items-end gap-1 pt-0.5 text-right">
          <AppBoardButton />
          <LastUpdateText />
        </div>
        {canShowButtons && (
          <div className="flex shrink-0 items-center gap-3">
            <ChangelogBell />
            <SwivuEntityFinder />
            <AppAddButton />
          </div>
        )}
      </div>
    </>
  );
}
